export default __webpack_public_path__ + "static/media/mockup-tela-lojista.88e399dc.png";